import { Box } from '@medely/ui-kit';
import React from 'react';
import { AssignmentCancel } from './components/AssignmentCancel';
import ContactFacility from '@mp/components/contactFacility/ContactFacility';
import { AssignmentForAssignmentDetailsGql } from '../graphql';
import { FragmentType, parseFragmentData } from '@mp/graphql/generated';

type AssignmentActionsProps = {
  assignment?: FragmentType<typeof AssignmentForAssignmentDetailsGql> | null;
  smallIcon?: boolean;
};

export const AssignmentActions = ({
  assignment: inputAssignment,
  smallIcon = false,
}: AssignmentActionsProps) => {
  const assignment = parseFragmentData(AssignmentForAssignmentDetailsGql, inputAssignment);

  const canBeCancelled = assignment?.status === 'booked';
  const bookedOrInProgress = ['booked', 'in_progress'].includes(assignment?.status ?? '');

  return (
    <Box pb={2}>
      {bookedOrInProgress && (
        <Box mb={2}>
          <ContactFacility
            contactableId={assignment?.id}
            type="assignment"
            phone={assignment?.facility_number}
            smallIcon={smallIcon}
          />
        </Box>
      )}
      {canBeCancelled && <AssignmentCancel />}
    </Box>
  );
};
